export default {
  schema: {
    type: 'object',
    required: ['requiredGroupedSelectQuestion', 'requiredGroupedMultiSelectQuestion'],
    properties: {
      selectQuestion: {
        title: 'Select Question',
        type: 'string',
        enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
        enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
      },
      multiSelectQuestion: {
        title: 'Multi-Select Question',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
          enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
        }
      },
      multiSelectQuestionLongOptions: {
        title: 'Multi-Select Question - long options',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option 1 Option 1 Option 1 Option 1 Option 1 Option 1 Option 1', 'Option 2 Option 2 Option 2 Option 2 Option 2 Option 2 Option 2', 'Option 3 Option 3 Option 3 Option 3 Option 3 Option 3 Option 3', 'Option 4 Option 4 Option 4 Option 4 Option 4 Option 4 Option 4', 'Option 5 Option 5 Option 5 Option 5 Option 5 Option 5 Option 5', 'Option 6 Option 6 Option 6 Option 6 Option 6 Option 6 Option 6'],
          enumNames: ['Option 1 Option 1 Option 1 Option 1 Option 1 Option 1 Option 1', 'Option 2 Option 2 Option 2 Option 2 Option 2 Option 2 Option 2', 'Option 3 Option 3 Option 3 Option 3 Option 3 Option 3 Option 3', 'Option 4 Option 4 Option 4 Option 4 Option 4 Option 4 Option 4', 'Option 5 Option 5 Option 5 Option 5 Option 5 Option 5 Option 5', 'Option 6 Option 6 Option 6 Option 6 Option 6 Option 6 Option 6']
        }
      },
      cbxQuestion: {
        title: 'Checkbox Question',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
          enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
        }
      },
      groupedSelectQuestion: {
        title: 'Grouped Select Question',
        type: 'string',
        enum: ['Option1', 'Option2', 'Option3', 'Option4', 'Option5', 'Option6']
      },
      grouped: {
        title: 'Grouped Multi-Select Question',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option1', 'Option2', 'Option3', 'Option4', 'Option5', 'Option6']
        }
      },
      requiredGroupedSelectQuestion: {
        title: 'Required Grouped Select Question',
        type: 'string',
        enum: ['Option1', 'Option2', 'Option3', 'Option4', 'Option5', 'Option6']
      },
      requiredGroupedMultiSelectQuestion: {
        title: 'Required Grouped Multi-Select Question',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option1', 'Option2', 'Option3', 'Option4', 'Option5', 'Option6']
        }
      }
    }
  },
  uiSchema: {
    selectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...'
    },
    multiSelectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...'
    },
    multiSelectQuestionLongOptions: {
      'ui:placeholder': 'Select...',
      'ui:widget': 'select'
    },
    cbxQuestion: {
      'ui:widget': 'checkboxes'
    },
    groupedSelectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...',
      'ui:options': {
        groupedOptions: [{
          label: 'Group 1',
          options: [{
            value: 'Option1',
            label: 'Option 1'
          }, {
            value: 'Option2',
            label: 'Option 2'
          }, {
            value: 'Option3',
            label: 'Option 3'
          }]
        }, {
          label: 'Group 2',
          options: [{
            value: 'Option4',
            label: 'Option 4'
          }, {
            value: 'Option5',
            label: 'Option 5'
          }, {
            value: 'Option6',
            label: 'Option 6'
          }]
        }]
      }
    },
    groupedMultiSelectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...',
      'ui:options': {
        groupedOptions: [{
          label: 'Group 1',
          options: [{
            value: 'Option1',
            label: 'Option 1'
          }, {
            value: 'Option2',
            label: 'Option 2'
          }, {
            value: 'Option3',
            label: 'Option 3'
          }]
        }, {
          label: 'Group 2',
          options: [{
            value: 'Option4',
            label: 'Option 4'
          }, {
            value: 'Option5',
            label: 'Option 5'
          }, {
            value: 'Option6',
            label: 'Option 6'
          }]
        }]
      }
    },
    requiredGroupedSelectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...',
      'ui:options': {
        groupedOptions: [{
          label: 'Group 1',
          options: [{
            value: 'Option1',
            label: 'Option 1'
          }, {
            value: 'Option2',
            label: 'Option 2'
          }, {
            value: 'Option3',
            label: 'Option 3'
          }]
        }, {
          label: 'Group 2',
          options: [{
            value: 'Option4',
            label: 'Option 4'
          }, {
            value: 'Option5',
            label: 'Option 5'
          }, {
            value: 'Option6',
            label: 'Option 6'
          }]
        }]
      }
    },
    requiredGroupedMultiSelectQuestion: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select...',
      'ui:options': {
        groupedOptions: [{
          label: 'Group 1',
          options: [{
            value: 'Option1',
            label: 'Option 1'
          }, {
            value: 'Option2',
            label: 'Option 2'
          }, {
            value: 'Option3',
            label: 'Option 3'
          }]
        }, {
          label: 'Group 2',
          options: [{
            value: 'Option4',
            label: 'Option 4'
          }, {
            value: 'Option5',
            label: 'Option 5'
          }, {
            value: 'Option6',
            label: 'Option 6'
          }]
        }]
      }
    },
    'dm:layout': [{
      type: 'field',
      id: 'selectQuestion'
    }, {
      type: 'field',
      id: 'multiSelectQuestion'
    }, {
      type: 'field',
      id: 'multiSelectQuestionLongOptions'
    }, {
      type: 'field',
      id: 'cbxQuestion'
    }, {
      type: 'field',
      id: 'groupedSelectQuestion'
    }, {
      type: 'field',
      id: 'groupedMultiSelectQuestion'
    }, {
      type: 'field',
      id: 'requiredGroupedSelectQuestion'
    }, {
      type: 'field',
      id: 'requiredGroupedMultiSelectQuestion'
    }]
  },
  formData: {}
};